import axios from 'axios'
import React, { useEffect } from 'react'
import { useHistory, useLocation } from 'react-router'
import { useUser } from '../contexts/user'

export default function AuthFacebook() {
  const queryParams = Object.fromEntries(
    new URLSearchParams(useLocation().search).entries()
  )
  const history = useHistory()
  const { setUser, setImage } = useUser()
  useEffect(() => {
    const fetchData = async () => {
      const authRes = await axios.get(
        'https://central.dartsee.com/auth/facebook/callback',
        {
          params: queryParams,
        }
      )
      const user = authRes.data
      const blob = await (
        await fetch(`https://mobile.dartsee.com/players/${user.id}.jpeg`, {
          cache: 'no-store',
        })
      ).blob()
      const imageBase64 = await new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onloadend = () => resolve(reader.result)
        reader.onerror = reject
        reader.readAsDataURL(blob)
      })
      setImage(imageBase64)
      setUser(user)
      history.push(
        `/home?sessionId=${localStorage.getItem(
          'sessionId'
        )}&boardId=${localStorage.getItem('boardId')}`
      )
    }
    fetchData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  return <div></div>
}
